module.exports = __webpack_public_path__ + "img/header-icon2.18227c72.jpg";